<div class="right-side p-5">
  <div class="pdf-container">
    <!-- Event Details -->
    <div class="event-details">
      <h2>Event Details</h2>

      <!-- Row 1 -->
      <div class="row">
        <div class="col-md-6" *ngIf="userType === 'MSME'">
          <label><b>Event ID:</b>&nbsp;</label><span>{{ eventId || 'N/A' }}</span>
        </div>
        <div class="col-md-6" *ngIf="userType === 'IA'">
          <label><b>Event ID:</b>&nbsp;</label><span>{{ shortEventName || 'N/A' }}</span>
        </div>
        <div class="col-md-6">
          <label><b>Event Name:</b>&nbsp;</label><span>{{ eventObj?.data?.[0]?.eventName || 'N/A' }}</span>
        </div>
      </div>

      <!-- Row 2 -->
      <div class="row">
        <div class="col-md-6">
          <label><b>Venue:</b>&nbsp;</label><span>{{ eventObj?.data?.[0]?.venueDetails || 'N/A' }}</span>
        </div>
        <div class="col-md-6">
          <label><b>Date:</b>&nbsp;</label><span>{{ eventObj?.data?.[0]?.eventDate || 'N/A' }}</span>
        </div>
      </div>

      <!-- Row 3 -->
      <div class="row">
        <div class="col-md-6">
          <label><b>Time:</b>&nbsp;</label><span>{{ eventObj?.data?.[0]?.time || 'N/A' }}</span>
        </div>
        <div class="col-md-6">
          <label><b>Duration of Event:</b>&nbsp;</label><span>{{ eventObj?.data?.[0]?.eventDuration || 'N/A' }}</span>
        </div>
      </div>

      <!-- Row 4 -->
      <div class="row">
        <div class="col-md-6">
          <label><b>Period:</b>&nbsp;</label><span>{{ eventObj?.data?.[0]?.period || 'N/A' }}</span>
        </div>
        <div class="col-md-6">
          <label><b>Event Organized By:</b>&nbsp;</label><span>{{ eventObj?.data?.[0]?.nameOfOrganisation || 'N/A' }}</span>
        </div>
      </div>

      <!-- Row 5 -->
      <div class="row mb-1">
        <div class="col-md-6" *ngIf="userType === 'MSME'">
          <label><b>Udyam Number:</b>&nbsp;</label><span>{{ msmeUserName || 'N/A' }}</span>
        </div>
      </div>
      <div class="row mb-1">
        <div class="col-md-6" *ngIf="userType === 'IA'">
          <label><b>Udyam Number:</b>&nbsp;</label><span>{{ udyamNumber || 'N/A' }}</span>
        </div>
      </div>
    </div>

    <hr /> <!-- Divider for better clarity -->
    <!-- Participants Details -->
    <h2>Participants Details</h2>
    <div *ngIf="!participantObj?.status">
      <p>No participants registered for this event.</p>
    </div>

    <!-- Table Wrapper -->
    <div class="participant-table">
      <table class="table table-striped table-bordered text-center">
        <thead class="thead-dark">
          <tr>
            <th>Sr. No.</th>
            <th>Enrollment ID</th>
            <th>Participant Name</th>
            <th>Email Id</th>
            <th>Mobile Number</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let participant of participantObj?.data; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ participant.enrollmentId }}</td>
            <td>{{ participant.participantName }}</td>
            <td>{{ participant.emailId }}</td>
            <td>{{ participant.mobileNumber }}</td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>

  <!-- Buttons -->
  <button type="submit" class="btn btn-warning" (click)="downloadPDF()">
    <i class="bi bi-filetype-pdf"></i> Download as PDF
  </button>
  <button type="submit" class="btn btn-success mx-2" (click)="sendEmailWithPDF()">Receive on Mail</button>
  <button type="submit" class="btn btn-info" (click)="onPressBack()">Back</button>
</div>



<!--<div class="container">-->
<!--<div class="right-side p-5">
  <div class="pdf-container">-->
<!--<div class="pdf-container">-->
<!--<div>
  <h2>Event Details</h2>-->
<!-- Row 1 -->
<!--<div class="container border p-3 mb-3">
  <h2 class="text-center mb-3">Event Details</h2>

  <div class="row mb-2">
    <div class="col-md-6">
      <label><b>Event ID:</b></label> <span>{{ eventId || 'N/A' }}</span>
    </div>
    <div class="col-md-6">
      <label><b>Event Name:</b></label> <span>{{ eventObj?.data?.[0]?.eventName || 'N/A' }}</span>
    </div>
  </div>

  <div class="row mb-2">
    <div class="col-md-6">
      <label><b>Venue:</b></label> <span>{{ eventObj?.data?.[0]?.venueDetails || 'N/A' }}</span>
    </div>
    <div class="col-md-6">
      <label><b>Date:</b></label> <span>{{ eventObj?.data?.[0]?.eventDate || 'N/A' }}</span>
    </div>
  </div>

  <div class="row mb-2">
    <div class="col-md-6">
      <label><b>Time:</b></label> <span>{{ eventObj?.data?.[0]?.time || 'N/A' }}</span>
    </div>
    <div class="col-md-6">
      <label><b>Duration:</b></label> <span>{{ eventObj?.data?.[0]?.eventDuration || 'N/A' }}</span>
    </div>
  </div>

  <div class="row mb-2">
    <div class="col-md-6">
      <label><b>Period:</b></label> <span>{{ eventObj?.data?.[0]?.period || 'N/A' }}</span>
    </div>
    <div class="col-md-6">
      <label><b>Organized By:</b></label> <span>{{ eventObj?.data?.[0]?.nameOfOrganisation || 'N/A' }}</span>
    </div>
  </div>

  <div class="row mb-2">
    <div class="col-md-6">
      <label><b>Udyam Number:</b></label> <span>{{ msmeUserName || 'N/A' }}</span>
    </div>
  </div>
</div>

<h2>Participants Details</h2>-->
<!--If no participants are available, show a message-->
<!--<div *ngIf="!participantObj?.status">
    <p>No participants registered for this event.</p>
  </div>

  <div class="container">
    <table class="table table-striped table-bordered text-center">
      <thead class="thead-dark">
        <tr>
          <th>Sr.No</th>
          <th>Enrollment ID</th>
          <th>Participant Name</th>
          <th>Email Id</th>
          <th>Mobile Number</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let participant of participantObj?.data; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ participant.enrollmentId }}</td>
          <td>{{ participant.participantName }}</td>
          <td>{{ participant.emailId }}</td>
          <td>{{ participant.mobileNumber }}</td>
        </tr>
      </tbody>
    </table>
  </div>


</div>-->
<!--</div>-->
<!--</div>
  <button type="submit" class="btn btn-warning" (click)="downloadPDF()">
    <i class="bi bi-filetype-pdf"></i>
    Download as PDF
  </button>
  <button type="submit" class="btn btn-success mx-2" (click)="sendEmailWithPDF()">Send on Email</button>
  <button type="submit" class="btn btn-info" (click)="onPressBack()">Back</button>
</div>-->
